import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconModule } from '@vg-constellation/angular-20/icon';

import { content } from '../../../../content/zci/content';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'zci-triage-tile',
    templateUrl: './triage-tile.component.html',
    styleUrls: ['./triage-tile.component.scss'],
    imports: [
        NgIf,
        IconModule,
    ],
})
export class TriageTileComponent {
    @Input() title: string;

    @Input() description: string;

    @Input() link: string;

    protected readonly environment = environment;

    protected readonly content = content;
}
